<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">四上企业报表</span>
      </div>
      <div class="title-right">
        <el-button v-if="canViewReport" type="primary" class="button-v2" @click="handleAdd">+ 四上报表生成</el-button>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          align="center"
          :columns="columns"
          :data="tableData"
          @change-filter="changeFilter"
          :operation-column-width="200"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="toDetail(row)">查看明细</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleExport(row)">报表下载</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleEdit(row)">编辑</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleDelete(row)">删除</span>
          </div>
        </template>
      </air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="queryParams.page"
          :page-size.sync="queryParams.limit"
          :total="total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>

    <el-dialog class="modal-v2" :title="modal.title" :visible.sync="modal.show" :close-on-click-modal="false" width="700px" append-to-body>
      <div class="flex vertical">
        <el-form ref="form" class="form-v2 report-form" :model="form" :rules="formRules" label-width="160px" style="margin: 40px 0; padding: 0 30px;" size="small">
          <el-form-item class="fixed-height" label="企业名称：" prop="cusId">
            <el-select v-model="form.cusId" placeholder="请选择企业" filterable>
              <el-option v-for="item in dictData.companyName" :key="item.id" :value="item.id" :label="item.companyName" />
            </el-select>
          </el-form-item>
          <el-form-item class="fixed-height" label="报表类型：" prop="reportType">
            <el-select v-model="form.reportType" placeholder="请选择报表类型" filterable>
              <el-option v-for="item in dictData.reportType" :key="item.codeItemId" :value="item.codeItemId" :label="item.codeItemName" />
            </el-select>
          </el-form-item>
          <el-form-item class="fixed-height" label="报表周期：" prop="reportCircle">
            <el-select v-model="form.reportCircle" placeholder="请选择报表周期" filterable>
              <el-option v-for="item in dictData.reportCircle" :key="item" :value="item" :label="item" />
            </el-select>
          </el-form-item>
          <el-form-item class="fixed-height" v-if="form.reportType === '40010002' || form.reportType === '40010004'" label="季度：" prop="reportCircleQ">
            <el-select v-model="form.reportCircleQ" placeholder="请选择季度" filterable>
              <el-option v-for="item in dictData.reportCircleQ" :key="item.codeItemId" :value="item.codeItemId" :label="item.codeItemName" />
            </el-select>
          </el-form-item>
          <el-form-item label="统计负责人：" prop="reportManager">
            <el-input v-model="form.reportManager" class="input-v2" placeholder="请输入统计负责人" maxlength="20" />
          </el-form-item>
          <el-form-item label="填表负责人：" prop="reportSubmitter">
            <el-input v-model="form.reportSubmitter" class="input-v2" placeholder="请输入填表负责人" maxlength="20" />
          </el-form-item>
          <el-form-item label="联系电话：" prop="reportTel">
            <el-input v-model="form.reportTel" class="input-v2" placeholder="请输入联系电话" maxlength="20" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="modal.show = false">取消</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>

    <air-confirm-v2
        :show.sync="confirmShow"
        :title="confirmTitle"
        :content="confirmContent"
        :confirm-function="confirmFunction"
    ></air-confirm-v2>

    <paid-modal :show.sync="paidModalShow"></paid-modal>
  </div>
</template>

<script>
import * as api from '@/api/v2/sishang/report'
import PaidModal from './components/PaidModal/index.vue'

export default {
  name: 'SishangReportList',
  components: {
    PaidModal
  },
  data() {
    return {
      canViewReport: false,
      loading: true,
      dictData: {},
      dictMap: {
        reportType: {},
        reportCircleQ: {}
      },
      queryParams: {
        page: 1,
        limit: 20,
      },
      total: 0,
      columns: [
        {title: '企业名称', field: 'companyName', minWidth: 150, filterType: 'input'},
        {title: '报表类型', field: 'reportTypeText', minWidth: 100, filterType: 'select', filterOptions: []},
        {title: '报表周期', field: 'reportCircleText', minWidth: 100},
        {title: '统计负责人', field: 'reportManager', minWidth: 100, filterType: 'input'},
        {title: '填表负责人', field: 'reportSubmitter', minWidth: 100, filterType: 'input'},
        {title: '联系电话', field: 'reportTel', minWidth: 100, filterType: 'input'},
      ],
      tableData: [],
      form: {},
      formRules: {
        cusId: [{ required: true, message: '请选择企业', trigger: 'change' }],
        reportType: [{ required: true, message: '请选择报表类型', trigger: 'change' }],
        reportCircle: [{ required: true, message: '请选择报表周期', trigger: 'change' }],
        reportCircleQ: [{ required: true, message: '请选择季度', trigger: 'change' }],
        reportManager: [{ required: true, message: '请输入统计负责人', trigger: 'blur' }],
        reportSubmitter: [{ required: true, message: '请输入填表负责人', trigger: 'blur' }],
        reportTel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      },
      modal: {
        show: false,
        title: '四上报表生成',
        edit: false
      },
      submitLoading: false,
      confirmShow: false,
      confirmTitle: '',
      confirmContent: '',
      confirmFunction: undefined,
      paidModalShow: false
    }
  },
  computed: {
  },
  created() {
    api.checkCanViewReport(this.$userInfo.cusId).then(res => {
      this.canViewReport = res.data.data.canViewReport === '10020001'
      if (this.canViewReport) {
        this.init()
      } else {
        this.paidModalShow = true
      }
    })
  },
  methods: {
    async init() {
      await this.getDictData()
      this.getData()
    },
    getDictData() {
      return api.selectReportSelectOpinion().then(res => {
        this.dictData = res.data.data
        this.dictData.reportType.forEach(item => {
          this.dictMap.reportType[item.codeItemId] = item.codeItemName
        })
        this.dictData.reportCircleQ.forEach(item => {
          this.dictMap.reportCircleQ[item.codeItemId] = item.codeItemName
        })
      })
    },
    getData() {
      this.loading = true
      api.selectSuperviseReportListByPage(this.queryParams).then(res => {
        this.columns[1].filterOptions = this.dictData.reportType
        res.data.data.records.forEach(item => {
          item.reportTypeText = this.dictMap.reportType[item.reportType]
          item.reportCircleText = item.reportType === '40010002' || item.reportType === '40010004' ? `${item.reportCircle}-${this.dictMap.reportCircleQ[item.reportCircleQ]}` : item.reportCircle
        })
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.loading = false
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    reset() {
      this.form = {
        cusId: undefined,
        reportType: undefined,
        reportCircle: undefined,
        reportCircleQ: undefined,
        reportManager: undefined,
        reportSubmitter: undefined,
        reportTel: undefined,
      }
      if (this.tableData.length) {
        this.form.reportManager = this.tableData[0].reportManager
        this.form.reportSubmitter = this.tableData[0].reportSubmitter
        this.form.reportTel = this.tableData[0].reportTel
      }
    },
    handleAdd() {
      this.reset()
      this.modal.title = '四上报表生成'
      this.modal.edit = false
      this.modal.show = true
    },
    handleEdit(item) {
      this.form = {
        id: item.id,
        cusId: item.cusId,
        reportType: item.reportType,
        reportCircle: item.reportCircle,
        reportCircleQ: item.reportCircleQ,
        reportManager: item.reportManager,
        reportSubmitter: item.reportSubmitter,
        reportTel: item.reportTel
      }
      this.modal.title = '四上报表编辑'
      this.modal.edit = true
      this.modal.show = true
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let saveApi = this.modal.edit ? api.updateSuperviseReportList : api.addSuperviseReportList
          saveApi(this.form).then(res => {
            if (res.data.code === 0) {
              this.$msgSuccess('保存成功')
              this.getData()
              this.modal.show = false
            }
          }).finally(() => this.submitLoading = false)
        }
      })
    },
    toDetail(item) {
      this.$go('/v2/sishang/report/detail', {
        title: item.reportName,
        id: item.id
      })
    },
    handleExport(item) {
      api.selectR001ForExport(item.id).then(res => {
        this.$downloadFile(res)
      })
    },
    handleDelete(item) {
      this.confirmShow = true
      this.confirmTitle = '删除四上报表'
      this.confirmContent = `确认删除四上报表「${item.reportName}」?`
      this.confirmFunction = () => {
        api.deleteSuperviseReportList(item.id).then(() => {
          this.getData()
          this.$msgSuccess('删除成功')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";


</style>
